module.exports = __webpack_public_path__ + "../static/img/mx.fc6673a1.png";